export enum CtaSurface {
  Page = 'PAGE',
  Popup = 'POPUP',
  FullPage = 'FULL_PAGE',
}

export interface CtaDefinition {
  /** Stable identity used for cooldown tracking and `@for` tracking. */
  id: string;
  /** i18n key for the chip label. */
  labelKey: string;
  /** Predefined prompt sent to the bot. `null` for static-only CTAs. */
  prompt: string | null;
  /** Display order within a page CTA list (1-based). */
  order: number;
  /** Cooldown duration in hours. `0` means no cooldown. */
  cooldownHours: number;
  /** Whether the CTA participates in the full-page chatbot experience. */
  availableOnFullPage: boolean;
  /** Fallback CTA, shown when every page/full-page CTA is in cooldown. */
  isFallback: boolean;
  /** Returns a predefined static response without any AI request. */
  isStaticResponse: boolean;
  /** i18n key for the static response body. `null` unless `isStaticResponse`. */
  staticResponseKey: string | null;
}
